// Lives outside the debug footer so the stream smoother (store code, on every
// route) does not drag the footer's debug UI into the shared app chunk.
export const streamingDebugProps: {
  stopStream: boolean
  nextTokenPromise?: PromiseWithResolvers<void>
} = {
  stopStream: false,
  nextTokenPromise: undefined,
}
